'use strict';
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _MenuOutlined = _interopRequireDefault(require('./lib/icons/MenuOutlined'));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _MenuOutlined;
  exports.default = _default;
  module.exports = _default;